import { Component, OnInit } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { investmentDurationOptions3 } from '@app/forms/subscription/services/ref';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { delay } from 'rxjs';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'bond-project-duration',
    templateUrl: './bond-project-duration.component.html',
    styleUrls: ['./bond-project-duration.component.scss'],
    standalone: false
})
export class BondProjectDurationComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  bondProjectDurationOptions = investmentDurationOptions3;
  error: ValidationErrors = null;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }
  ngOnInit() {
    this.subscriptionFacade.initForm(this);
    this.formValueChanges();
  }
  formValueChanges() {
    this.form
      .get('investmentDuration')
      .valueChanges.pipe(delay(0), untilDestroyed(this))
      .subscribe(data => {
        if (data == 'MINUS_FIVE') {
          this.form.get('investmentDuration').setErrors({
            incorrect: true,
            message:
              "Vous ne pouvez pas sélectionner cette option. La durée d'investissement est trop courte.",
          });
        } else {
          this.form.get('investmentDuration').setErrors(null);
        }
        this.error = this.form.get('investmentDuration').errors;
      });
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
